import { render, staticRenderFns } from "./CheckToken.vue?vue&type=template&id=186d600b"
import script from "./CheckToken.vue?vue&type=script&lang=js"
export * from "./CheckToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports